import { TokenStorage } from './TokenStorage';

export const getToken = (): string | null => TokenStorage.get();
